import { Text, View } from '@react-pdf/renderer';

const Tools = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox} wrap={false}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.skills}>
				{data?.map((res: any, index: number) => (
					<View key={`${res?.title}-${index}`} style={styles.skillsBox}>
						<Text style={styles.skillsText}>{res?.title}</Text>
					</View>
				))}
			</View>
		</View>
	);
};

export default Tools;
